import { Card, Badge, Col, Row } from 'react-bootstrap';
import { formatCurrency } from '../../../../utils/formatters';

const ReadOnlyLiheapBenefit = ({ pledgeAmount, additionalInformation }) => {

  return (
    <Card className="mt-3">
      <Card.Header>Benefit Amount</Card.Header>
      <Card.Body>
        <Row>
          <Col md={3}>
            <span>Pledge Amount:</span>
          </Col>
          <Col md={3}>
            <Badge bg="success">{formatCurrency(pledgeAmount)}</Badge>
          </Col>
          <Col>
            <span>Additional Information:</span>
            <span> {additionalInformation}</span>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ReadOnlyLiheapBenefit;